// src/components/ui/Header.jsx
import React, { useEffect, useState, useRef } from "react";
import { getDisplayName, signOut } from "../../lib/cognito";

export default function Header() {
  const [displayName, setDisplayName] = useState("User");
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    getDisplayName().then((name) => {
      if (name) setDisplayName(name);
    });
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    signOut();
    window.location.href = "/login-screen";
  };

  return (
    <header
      className="flex justify-between items-center px-6 py-3.5"
      style={{
        background: "rgba(6,13,28,0.85)",
        borderBottom: "1px solid rgba(255,255,255,0.07)",
        backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
      }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 cursor-default select-none">
        <div
          className="w-8 h-8 rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0"
          style={{ background: "linear-gradient(135deg, #1D4ED8, #0EA5E9)" }}
        >
          <img
            src="/assets/images/graftcounter-logo.png"
            alt="Graft Counter"
            className="w-full h-full object-contain"
          />
        </div>
        <span
          className="font-semibold tracking-tight"
          style={{ color: "rgba(255,255,255,0.92)", fontSize: "0.975rem" }}
        >
          Graft Counter
        </span>
        <span
          className="text-[10px] px-1.5 py-0.5 rounded font-semibold tracking-widest"
          style={{
            background: "rgba(59,130,246,0.18)",
            color: "#93C5FD",
            border: "1px solid rgba(59,130,246,0.28)",
          }}
        >
          AI
        </span>
      </div>

      {/* User Menu */}
      <div className="relative" ref={menuRef}>
        <button
          onClick={() => setMenuOpen((p) => !p)}
          className="flex items-center gap-2.5 px-3 py-1.5 rounded-lg transition-all duration-150"
          style={{
            color: "rgba(255,255,255,0.7)",
            background: menuOpen
              ? "rgba(255,255,255,0.08)"
              : "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.09)",
          }}
        >
          <div
            className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
            style={{
              background: "linear-gradient(135deg, #1D4ED8, #0EA5E9)",
              color: "white",
            }}
          >
            {displayName.charAt(0).toUpperCase()}
          </div>
          <span
            className="text-sm font-medium"
            style={{ color: "rgba(255,255,255,0.85)" }}
          >
            {displayName}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="11"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`transition-transform duration-200 ${menuOpen ? "rotate-180" : ""}`}
            style={{ color: "rgba(255,255,255,0.35)" }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        {menuOpen && (
          <div
            className="absolute right-0 mt-2 w-36 rounded-xl overflow-hidden z-50"
            style={{
              background: "rgba(8,16,36,0.97)",
              border: "1px solid rgba(255,255,255,0.1)",
              backdropFilter: "blur(20px)",
              boxShadow: "0 12px 32px rgba(0,0,0,0.5)",
            }}
          >
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-3 text-sm transition-all duration-100"
              style={{ color: "rgba(255,255,255,0.65)" }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(255,255,255,0.07)";
                e.currentTarget.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "rgba(255,255,255,0.65)";
              }}
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
